import React from 'react';
import { useParams } from 'react-router';

import { queryClient } from '@/src/lib/react-query/react-query';

import { useAddLibraryMember } from '../../../../api/addLibraryMember';
import { useDeleteLibraryMember } from '../../../../api/deleteLibraryMember';
import { getLibraryMembersQueryKey, useGetLibraryMembers } from '../../../../api/getLibraryMembers';
import ManageAccessList, {
  MemberActionInput,
} from '../../../Modal/ManageAccessList/ManageAccessList';

const LibraryManageAccessList = ({ onClose }) => {
  const { projectId } = useParams<{ projectId: string }>();
  const addLibraryMemberMutation = useAddLibraryMember();
  const deleteLibraryMemberMutation = useDeleteLibraryMember();
  const libraryMembersQuery = useGetLibraryMembers({ projectId: +projectId });

  const handleAdd = ({ memberId }: MemberActionInput) => {
    return addLibraryMemberMutation.mutateAsync({
      projectId: +projectId,
      memberId,
    });
  };

  const handleDelete = ({ memberId }: MemberActionInput) => {
    return deleteLibraryMemberMutation.mutateAsync({
      projectId: +projectId,
      memberId,
    });
  };

  return (
    <ManageAccessList
      onClose={onClose}
      onAdd={handleAdd}
      onDelete={handleDelete}
      libraryMembersQuery={libraryMembersQuery}
      onSaved={() => queryClient.invalidateQueries({ queryKey: getLibraryMembersQueryKey.list })}
    />
  );
};

export default LibraryManageAccessList;
